import styled from "styled-components/macro";
import { COLORS } from "../../../layout/theme";

export const Page = styled.div`
	min-height: 100vh;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 32px 16px;
	background: #f4f5f7;
	position: relative;
	overflow: hidden;

	&::before {
		content: "";
		position: absolute;
		inset: 0;
		background-image:
			radial-gradient(
				circle at 20% 20%,
				rgba(24, 95, 165, 0.06) 0%,
				transparent 50%
			),
			radial-gradient(
				circle at 80% 80%,
				rgba(27, 58, 107, 0.05) 0%,
				transparent 50%
			);
		pointer-events: none;
	}

	&::after {
		content: "";
		position: absolute;
		inset: 0;
		background-image: radial-gradient(circle, #cbd5e1 1px, transparent 1px);
		background-size: 28px 28px;
		opacity: 0.35;
		pointer-events: none;
	}
`;

export const Main = styled.div`
	position: relative;
	z-index: 1;
	width: 100%;
	max-width: 650px;
	display: flex;
	flex-direction: column;
	align-items: center;
	animation: fadeUp 0.4s ease both;

	@keyframes fadeUp {
		from {
			opacity: 0;
			transform: translateY(16px);
		}
		to {
			opacity: 1;
			transform: translateY(0);
		}
	}
`;

export const LogoWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	margin-bottom: 28px;
`;

export const Header = styled.div`
	text-align: center;
	width: 100%;
	background: ${COLORS.White};
	border: 1px solid #e4e6ea;
	border-radius: 16px 16px 0 0;
	border-bottom: none;
	padding: 30px 32px 0;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

	@media only screen and (max-width: 520px) {
		padding: 24px 20px 0;
	}
`;

export const HeaderTitle = styled.h1`
	font-size: 22px;
	font-weight: 600;
	color: #111827;
	letter-spacing: -0.03em;
	margin: 0 0 6px 0;
`;

export const HeaderDesc = styled.p`
	font-size: 13px;
	color: #6b7280;
	line-height: 1.5;
	margin: 0 0 24px 0;
`;

export const Body = styled.div`
	width: 100%;
	background-color: ${COLORS.White};
	border: 1px solid #e4e6ea;
	border-top: none;
	border-radius: 0 0 16px 16px;
	padding: 0 32px 32px;
	box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);

	.ant-form {
		width: 100%;
	}

	.ant-form-item {
		margin-bottom: 14px;
	}

	.ant-form-item-explain-error {
		font-size: 12px;
	}

	.ant-input,
	.ant-input-affix-wrapper {
		height: 42px;
		background: #f8f9fa;
		border: 1px solid #e4e6ea;
		border-radius: 8px;
		box-shadow: none;
	}

	.ant-input-affix-wrapper .ant-input {
		height: auto;
		background: transparent;
		border: none;
	}

	.ant-input:focus,
	.ant-input-focused,
	.ant-input-affix-wrapper:focus,
	.ant-input-affix-wrapper-focused {
		border-color: #185fa5;
		background: #ffffff;
		box-shadow: 0 0 0 3px rgba(24, 95, 165, 0.1);
	}

	.ant-input-prefix,
	.ant-input-password-icon {
		color: #9ca3af;
	}

	@media only screen and (max-width: 520px) {
		padding: 0 20px 24px;
	}
`;

export const InnerForm = styled.div`
	display: flex;
	flex-direction: column;
`;

export const AlertBox = styled.div`
	background: #fef2f2;
	border: 1px solid #fecaca;
	color: #b91c1c;
	padding: 12px 14px;
	border-radius: 10px;
	font-size: 13px;
	line-height: 1.5;
	margin-bottom: 16px;
`;

export const Section = styled.div`
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
`;

export const ForgotLinkWrap = styled.div`
	margin-top: -4px;
	margin-bottom: 6px;
	text-align: center;
`;

export const ForgotLink = styled.div`
	a {
		font-size: 12px;
		color: #185fa5;
		text-decoration: none;
	}

	a:hover {
		opacity: 0.8;
		text-decoration: underline;
	}
`;

export const Divider = styled.div`
	display: flex;
	align-items: center;
	gap: 12px;
	margin: 22px 0;
`;

export const DividerLine = styled.div`
	flex: 1;
	height: 1px;
	background: #e4e6ea;
`;

export const DividerText = styled.span`
	font-size: 11px;
	color: #9ca3af;
	font-weight: 500;
	letter-spacing: 0.05em;
	text-transform: uppercase;
	white-space: nowrap;
`;

export const PrimaryButtonWrap = styled.div`
	display: flex;
	justify-content: center;

	.ant-btn {
		width: 70%;
		height: 44px;
		border-radius: 8px;
		border: none;
		background: ${COLORS.Primary};
		box-shadow: 0 2px 8px rgba(27, 58, 107, 0.2);
		font-size: 14px;
		font-weight: 500;
	}

	.ant-btn:hover,
	.ant-btn:focus,
	.ant-btn:active {
		background: ${COLORS.Primary} !important;
		color: white !important;
		border: none !important;
		box-shadow: 0 4px 12px rgba(27, 58, 107, 0.28);
	}
`;

export const SecondaryButton = styled.button`
	width: 100%;
	height: 44px;
	background: #ffffff;
	color: #111827;
	border: 1px solid #e4e6ea;
	border-radius: 8px;
	font-size: 14px;
	font-weight: 500;
	font-family: inherit;
	cursor: pointer;
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	transition:
		background 0.15s,
		border-color 0.15s,
		transform 0.1s;
	letter-spacing: -0.01em;

	&:hover {
		background: #f8f9fa;
		border-color: #b0b7c3;
		transform: translateY(-1px);
	}
`;

export const ButtonSection = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;

	svg {
		flex-shrink: 0;
	}
`;

export const Footer = styled.div`
	margin-top: 20px;
	text-align: center;
	font-size: 12px;
	color: #9ca3af;
	line-height: 1.5;

	a {
		color: ${COLORS.Primary};
		text-decoration: none;
		font-weight: 500;
	}

	a:hover {
		text-decoration: underline;
	}
`;

export const TrustRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 14px;
	flex-wrap: wrap;
	margin-top: 22px;
`;

export const TrustItem = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	font-size: 11px;
	color: #9ca3af;
`;

export const TrustDot = styled.div`
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background: #b0b7c3;
`;
